<template>
    <div class="park-glace">
        <!-- 标题 -->
        <div class="public-module-title">
            <img src="@/assets/images/publicTitle.png" alt="">
            <div>稻乡渔歌</div>
        </div>
        <div class="introduce">
            <img class="introduceImg" src="@/assets/images/parkStyle/banner/img (17).jpg" alt="">
            <div class="info" ref="info" @mouseenter="enter" @mouseleave="leave">
                <p>稻乡渔歌现代农业产业园位于大邑县沙渠街道祥龙社区，建设有川西林盘7个和集中居住区1个，规划面积达15000亩。 “稻乡渔歌”林盘聚落获选2019年度成都市“十大最美川西林盘”。</p>
                <p>稻乡渔歌是成都市朗基产业集团“乡村振兴”项目的标杆之作。包含农业、民宿、康养、文博、教育、田园共六大产业体系，以构建具有中国特色的现代农业产业示范园区。具体功能分区包括：学养产业园、文创商业核心区、川西记忆时光、生态示范区、农业示范区、禅修文化区。</p>
                <p>以“产景相融、产旅一体、产村互动”为基本思路，深挖区域农耕文化，做强特色农业，打造高品质主题民宿、农博体验和康养基地，打造农业公园，深度推进农商文旅体融合发展。吸引产业、人才扎根乡村振兴的“共生经济”模式正在继续创新实践。</p>
                <p>“留住乡村特色、留住当地居民、留住投资企业、留住支柱产业是我们的任务和使命。”朗基控股集团负责人向考察组介绍道，稻乡渔歌就是要打造一个共生模式的平台，高品质农业、农创、文创、康养、主题民宿都能在这里找到发展空间。</p>
                <p>近千亩稻田像一块碧玉，镶嵌在蜿蜒而过的西江河畔，田埂上树木林立，稻田旁的林盘里，青砖灰瓦的川西小院乡风浓郁，草坪花卉和打造的湖泊让祥和新村的村民如同居住在了公园里。</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: '',
  data () {
    return {
    }
  },
  created () {
  },
  destroyed(){
  },
  mounted () {
    this.scrollFn()
  },
  methods: {
    scrollFn(){
        const divData = this.$refs.info
        if(divData){
            this.timer=setInterval(()=>{
                divData.scrollTop += 1;
                if(divData.clientHeight + divData.scrollTop == divData.scrollHeight){
                    divData.scrollTop = 0
                }
            },80)
        }
    },

    enter(){
        clearInterval(this.timer)
    },

    leave(){
        const divData2 = this.$refs.info
        this.timer = setInterval(()=>{
            divData2.scrollTop += 1;
            if(divData2.clientHeight + divData2.scrollTop == divData2.scrollHeight){
                divData2.scrollTop = 0
            }
        },80)
    },
  },
  
}
</script>
<style lang="less" scoped>
.introduce{
    // 修改滚动条样式
    ::-webkit-scrollbar {
        width: 2px;    
    }
    ::-webkit-scrollbar-thumb {
        border-radius: 10px;
        box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        background: rgba(22, 138, 130, 0.82);
    }
    ::-webkit-scrollbar-track {
        box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        border-radius: 0;
        background: rgba(26, 120, 114, 0.28);
    }
    
    .introduceImg{
        height: 280px;
        width: 100%;
        margin-top: 12px;
    }
    .info{
        font-size: 16px;
        line-height: 24px;
        margin-top: 16px;
        height: 200px;
        overflow: auto;
        p{
            text-indent: 2em;
        }
        
    }
}
</style>
